import React from "react";
import { Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Post } from "../../AxiosCRUDFunctions";
import Button from "../../components/Button";
import CommonCard from "../../components/CommonCard";
import FormWrapper from "../../components/FormWrapper";
import { Input } from "../../components/Input";
import { BaseURL, apiHeader } from "../../config";
import classes from "./UpdatePasswordModal.module.css";
import { WALogin } from "../../store/authSlice";
import { useDispatch } from "react-redux";

const UpdatePasswordModal = ({ show, setShow, data, setData, cancelHandler, isSetting = true }) => {

  const dispatch = useDispatch();
  const { token } = useSelector((state) => state?.authReducer);
  const changePasswordHandler = async () => {
    if (
      data?.currentPassword &&
      data?.password &&
      data?.confirmPassword
    ) {
      if (
        data?.password === data?.confirmPassword
      ) {
        const body = {
          currentPassword: data?.currentPassword,
          password: data?.password,
        };
        const response = await Post(
          BaseURL("SignUp/ChangePassword"),
          body,
          apiHeader(token)
        );
        if (response != undefined && response?.data?.headers.error === 200) {
          toast.success("Password Updated Successfully");
          dispatch(WALogin({ isWANewLogin: false }));
          cancelHandler();
        } else {
          toast.error(response?.data.headers?.message);
        }
      } else {
        toast.error("Password and Confirm Password must be same");
      }
    } else {
      toast.error("Required fields must be filled");
    }
  };
  return (
    <>
      <style>{`
      .modal-md {
        --bs-modal-width: 500px;
      }
      .modal-content{
        border-radius: 16px;
      }
    `}</style>
      <Modal
        show={show}
        // onHide={setShow}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        autoScrollable={false}
      >
        <CommonCard className={classes["extraCardStyles"]}>
          <div className={classes["heading-wrapper"]}>
            <h1>Update Your Password</h1>
            <p>Update your account password for enhanced security.</p>
          </div>
          <FormWrapper>
            <Row>
              <Input
                label={"Current Password"}
                value={data?.currentPassword}
                setter={(val) =>
                  setData((prev) => ({ ...prev, currentPassword: val }))
                }
                placeholder={"Enter Current Password"}
                type={"password"}
                required={true}
                labelStyle={{ fontWeight: 600 }}
              />
            </Row>
            <Row>
              <Input
                label={"New Password"}
                value={data?.password}
                setter={(val) =>
                  setData((prev) => ({ ...prev, password: val }))
                }
                placeholder={"Enter New Password"}
                type={"password"}
                labelStyle={{ fontWeight: 600 }}
                required={true}
              />
            </Row>
            <Row>
              <Input
                label={"Confirm Password"}
                value={data?.confirmPassword}
                setter={(val) =>
                  setData((prev) => ({ ...prev, confirmPassword: val }))
                }
                placeholder={"Enter Confirm Password"}
                type={"password"}
                required={true}
                labelStyle={{ fontWeight: 600 }}
              />
            </Row>
          </FormWrapper>
          <div className={classes["action-wrapper"]}>
            <Button
              label={isSetting ? "Cancel" : "Logout"}
              type="button"
              className={classes["cancel-button"]}
              onClick={setShow}
            />
            <Button
              label="Update Password"
              onClick={changePasswordHandler}
              className={classes["signIn-btn"]}
            />
          </div>
        </CommonCard>
      </Modal>
    </>
  );
};

export default UpdatePasswordModal;
